<template>
	<div>
		<page-title-bar></page-title-bar>
		<app-section-loader :status="loader"></app-section-loader>

		<v-container fluid grid-list-xl pt-0>
		

				<app-card>
                	<v-btn color="success" @click="save" name="btnsave" class="text-xs-right" :disabled="disable">Opslaan</v-btn>
					
					<v-card flat>
						<v-card-text>
							<v-layout row wrap>
								<v-flex xl12 lg12 md12 sm12 xs12>
									<span class="small pt-4 d-block"><h4>Algemene instellingen</h4></span>
								</v-flex>
								<v-flex xl12 lg12 md12 sm12 xs12>
									<v-checkbox color="primary" :label="`Verberg medewerkers keuze`" v-model="record.IsHideUserChoice"></v-checkbox>
									<span style='font-size: x-small;'>De klant krijgt in dit geval geen keuzemenu uit medewerkers waaruit ze kunnen kiezen.<br> 
									Indien je alleen werkt vink je deze best aan.</span>
								</v-flex>
     
			      		<v-flex xs6></v-flex>
							</v-layout>
						</v-card-text>
					</v-card>

                    <h4>Afspraak module instellingen</h4>
					<v-card flat>
						<v-card-text>
							<v-layout row wrap>

								<v-flex xl6 lg6 md6 sm6 xs6>
									<span class="small pt-4 d-block">Themakleur</span>
								</v-flex>
								<v-flex xl6 lg6 md6 sm6 xs6>
									<swatches v-model="record.ColorAppoint"  colors="text-advanced" shapes="circles"></swatches>
								</v-flex>

                                <v-flex xl6 lg6 md6 sm6 xs63>
									<span class="small pt-4 d-block">Blokkeer online reserveren na x maanden</span>
									<span style='font-size: x-small;'>De klant kan dan na x maanden in de toekomst niet meer online boeken.</span>
								</v-flex>
								<v-flex xl6 lg6 md6 sm6 xs6>
									<v-select  hide-details v-bind:items="record.QtyMaxMonthFutureLst"  v-model="record.QtyMaxMonthsFutue"  label="Instellen max einddatum" item-text="Descr" item-value="Key"  single-line  menu-props="bottom" ></v-select>
								</v-flex>
			
                                <v-flex xl6 lg6 md6 sm6 xs6>
									<span class="small pt-4 d-block">Tijdsinterval keuze</span>
								</v-flex>
								<v-flex xl6 lg6 md6 sm6 xs6>
									<v-select  hide-details v-bind:items="record.TimeIntervals"  v-model="record.QtyTimeInterval"  label="Kies interval" item-text="Descr" item-value="Key"  single-line  menu-props="bottom" ></v-select>
								</v-flex>
                       
							</v-layout>
						</v-card-text>
					</v-card>
                    <h4>Links</h4>
					<v-card flat>
						<v-card-text>
							<v-layout row wrap>
                    
                                <v-flex xl6 lg6 md6 sm6 xs6>
									<span class="small pt-4 d-block">Url online module</span>
								</v-flex>
                                <v-flex xl6 lg6 md6 sm6 xs6>
                                    <v-text-field name="input-1" label="Url site" id="testing" v-model="record.UrlSite"></v-text-field> <br>
									<v-btn color="success"  v-bind:href="record.UrlSite" target="_blank" class="text-xs-right">Bezoek site</v-btn>
                                </v-flex>

                                 <v-flex xl6 lg6 md6 sm6 xs6>
									<span class="small pt-4 d-block">Iframe</span>
								</v-flex>
                                 <v-flex xl6 lg6 md6 sm6 xs6>
                                    <v-textarea v-model="record.UrlIFrame"></v-textarea>
                                </v-flex>
						
							</v-layout>
						</v-card-text>
					</v-card>
				</app-card>

					

		</v-container>
		<v-container fluid grid-list-xl pt-0>
		<app-card flat
						:heading="$t('message.errors')"
						colClasses="xl6 md6 sm12 xs12"
						customClasses="mb-0">
						<span id="rptTrans">
							<v-data-table :items="record.ErrorsLines" hide-actions>
								
								<template slot="items" slot-scope="props">
									<td> {{ props.item }}</td>
								</template>
								
							</v-data-table>
						</span>
					</app-card>
		</v-container>

	</div>
</template>

<script>
import myHttpApi from "../../api/myHttpApi";
import router from '../../router';

import Swatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.min.css";

export default {
  data() {
    return {
        loader: true,
        disable: false,
		record: {},
		color: '#EEEEEE',
        itemsFreePlaces : {}
    };
  },
   components: {
     Swatches
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    cancel ()  {
        router.go (-1);
    },
    save () {
		//this.record.ColorStr = this.color;
        myHttpApi.post('BOSettings/SaveOnlineConfig', this.record)
        .then(response => {
            this.loader = false;

            if (response.data.ResultCode != 200)
            {
                alert (response.data.ResultMessage);
            }
            else
            {
                this.disable = true;
            }
        })
        .catch(error => {
            console.log(error);
        });
    },
    getTableData() {
      myHttpApi
		myHttpApi.post('BOSettings/GetOnlineConfig')
        .then(response => {
          this.loader = false;
          this.record = response.data;
        })
        .catch(error => {
          console.log(error);
        });
	}
  }
};
</script>